import Modal from '@components/v2/ui/Modal/Modal';
import LangEnum from '../../lang/LangEnum';
import { AnnouncementContent } from '../../services/modules/announcements/announcements.types';
import AnnouncementDetails from './AnnouncementDetails';

interface AnnouncementModalProps {
  isOpen: boolean;
  publishedAt: string;
  content: AnnouncementContent;
  onClose: () => void;
}

const AnnouncementModal = ({ isOpen, publishedAt, content, onClose }: AnnouncementModalProps) => (
  <Modal
    isOpen={isOpen}
    size="expanded"
    header={{ title: LangEnum.ANNOUNCEMENTS_TITLE }}
    onClose={onClose}
  >
    <AnnouncementDetails publishedAt={publishedAt} content={content} />
  </Modal>
);

export default AnnouncementModal;
